export function cancellationErrorMessage(err) {
  const status = err && err.response && err.response.status;
  if (status === 409) return 'This analysis has already finished and cannot be cancelled. Refresh the list to see its latest status.';
  if (status === 404) return 'This analysis is no longer available. Refresh the list.';
  return 'Cancellation could not be confirmed. Try again.';
}

/** The lock covers confirmation as well as submission; invalidation prevents an old dialog acting in a new view. */
export function createJobCancellationController({ confirm, cancel, getContext, onBusy, onSuccess, onError }) {
  const pending = new Map();
  let generation = 0;
  function invalidate() {
    generation++;
    pending.forEach((value, id) => onBusy(id, false));
    pending.clear();
  }
  async function run(job) {
    if (!job || pending.has(job.id)) return;
    const token = {};
    const context = getContext();
    const version = generation;
    const isCurrent = () => generation === version && getContext() === context;
    pending.set(job.id, token);
    onBusy(job.id, 'confirming');
    try {
      const confirmed = await confirm(job);
      if (!confirmed || !isCurrent()) return;
      onBusy(job.id, 'submitting');
      const result = await cancel(job, context);
      if (isCurrent()) onSuccess(result);
    } catch (err) {
      if (isCurrent()) onError(err);
    } finally {
      if (pending.get(job.id) === token) {
        pending.delete(job.id);
        onBusy(job.id, false);
      }
    }
  }
  return { run, invalidate };
}
